// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerOrderApi } from "../../services/Api/CustomerOrderApi"
import { getCustomerOrderList, getErrors } from "../reducers/CustomerOrderReducer"

// Watchers
function* customerOrderSaga() {
	yield takeEvery("customerOrder_list/getCustomerOrder", getOrder)
}

// Sagas
function* getOrder(action) {
	// console.log(action)
	try {
		const getCustomerOrder = yield call(getCustomerOrderApi, action.payload)
		
		if (getCustomerOrder.request.status === 200) {
			yield put(getCustomerOrderList(getCustomerOrder))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
      
        
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerOrderSaga)])
}
